import { DataSaverOff, GroupAdd, Person, VideoLabel } from '@mui/icons-material';
import { Step, StepLabel, Stepper, styled } from '@mui/material'
import React from 'react'



const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 40,
    height: 40,
    marginBottom: 20,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    ...(ownerState.active && {
      backgroundImage:
        "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
      boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
    }),
    ...(ownerState.completed && {
      backgroundImage:
        "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    }),
  }));

  function ColorlibStepIcon(props) {
    const { active, completed, className, icon } = props;

    const icons = {
      1: <img
        src={"/assets/images/purpose.png"}
        style={{ width: 40, height: 40, borderRadius: 10 }}
        tintColor="#fff"
      />,
      2: <DataSaverOff />,
      3: <Person />,
      4: <GroupAdd />,
      5: <VideoLabel />,
    };

    return (
      <ColorlibStepIconRoot
        ownerState={{ completed, active }}
        className={className}
        style={{ marginBottom: 10 }}
      >
        {icons[String(icon)]}
      </ColorlibStepIconRoot>
    );
  }

  const steps = [
    "Description",
    "Purpose of loan",
    "Benefactor Information",
    "Case Information",
    "Co-Applicant Information",
  ];

export default function FormStep({ activeStep }) {
  return (
        <Stepper activeStep={activeStep} alternativeLabel >
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel StepIconComponent={ColorlibStepIcon} />
            </Step>
          ))}
        </Stepper>
  )
}
